import React, { useState, useEffect } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import {
  CardContent,
  RadioGroup,
  Box,
  FormControlLabel,
  Radio,
  Typography,
  Stack,
} from "@mui/material";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import { useNavigate } from "react-router-dom";
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import commonMessages from "../../utility/constant";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import axios from "axios";

function Workorderinhousevsoutsource() {
  const navigate = useNavigate();
  const allMonths = commonMessages.months;
  //const all = { label: "All", value: "All", id: "0" };
  const currentYear = new Date().getFullYear();
  const currentMonthIndex = new Date().getMonth();

  const [selectedType, setSelectedType] = useState("schedule");
  const [year, setYear] = useState({ label: currentYear.toString(), value: currentYear.toString() });
  const [month, setMonth] = useState(allMonths[currentMonthIndex]);
  const [monthsOptions, setMonthsOptions] = useState([]);
  const [yearsOptions, setYearsOptions] = useState([]);
  const [responseFem, setResponseFemwoage] = useState({});
  const [responseBem, setResponseBemwoage] = useState({});

  const fetchMaintenanceYears = async () => {
    const facilityid = localStorage.getItem("facilityId");
    try {
      const response = await axios.get(`${MasterGraph}/api/GraphMaintenanceYear/GetMaintenanceYearByFacilityId/${facilityid}?page=1&size=100`);
      const years = response.data.items.map(y => ({ label: y.maintyearvalue.toString(), value: y.maintyearvalue.toString() }));
      setYearsOptions(years);
    } catch (error) {
      console.error("Error fetching maintenance years:", error);
    }
  };

  const fetchDataWoageing = async () => {
    try {
      const token = getAuthToken("id_token");
      const facilityId = getFacilityId();
      const config = { headers: { Authorization: `Bearer ${token}` } };

      const [responseFemwoage, responseBemwoage] = await Promise.all([
        axios.get(`${FemsGraph}/api/FEMSDashboardWidgets/GetDashboardCountWOageing/${facilityId}/${month?.id}/${year?.value}/2`, config),
        axios.get(`${BemsGraph}/api/BEMSDashboardWidgets/GetDashboardCountWOageing/${facilityId}/${month?.id}/${year?.value}/2`, config),
      ]);

      setResponseFemwoage(responseFemwoage.data);
      setResponseBemwoage(responseBemwoage.data);
    } catch (error) {
      console.error("Error fetching work order ageing data:", error);
    }
  };

  useEffect(() => {
    const selectedYear = parseInt(year.value);
    const months =
      selectedYear === currentYear
        ? [ ...allMonths.slice(0, currentMonthIndex + 1)]
        : [ ...allMonths];

    setMonthsOptions(months);
    setMonth(selectedYear === currentYear ? allMonths[currentMonthIndex] : allMonths[0]);
  }, [year]);

  useEffect(() => {
    fetchMaintenanceYears();
    fetchDataWoageing();
  }, [year, month]);

  const handleYearChange = (newValue) => setYear(newValue);
  const handleMonthChange = (newValue) => setMonth(newValue);
  const handleRadioChange = (event) => setSelectedType(event.target.value);

  const pieData = selectedType === "schedule"
    ? [
      {
        id: 0,
        value: (responseFem.totalInhouseScheduledWOCount || 0) + (responseBem.totalInhouseScheduledWOCount || 0),
        label: `Inhouse (${(responseFem.totalInhouseScheduledWOCount || 0) + (responseBem.totalInhouseScheduledWOCount || 0)})`,
        color: "#EF0107",
      },
      {
        id: 1,
        value: (responseFem.totalOutsourceScheduledWOCount || 0) + (responseBem.totalOutsourceScheduledWOCount || 0),
        label: `Outsource (${(responseFem.totalOutsourceScheduledWOCount || 0) + (responseBem.totalOutsourceScheduledWOCount || 0)})`,
        color: "#4CAF50",
      },
    ]
    : [
      {
        id: 0,
        value: (responseFem.totalInhouseUnscheduledWOCount || 0) + (responseBem.totalInhouseUnscheduledWOCount || 0),
        label: `Inhouse (${(responseFem.totalInhouseUnscheduledWOCount || 0) + (responseBem.totalInhouseUnscheduledWOCount || 0)})`,
        color: "#EF0107",
      },
      {
        id: 1,
        value: (responseFem.totalOutsourceUnscheduledWOCount || 0) + (responseBem.totalOutsourceUnscheduledWOCount || 0),
        label: `Outsource (${(responseFem.totalOutsourceUnscheduledWOCount || 0) + (responseBem.totalOutsourceUnscheduledWOCount || 0)})`,
        color: "#4CAF50",
      },
    ];

  const handlePieClick = (event, item) => {
    navigate("/workorder", { state: { tab: selectedType === "schedule" ? 1 : 2, year: year?.value, month: { value: month?.value, label: month?.label, id: month?.id  } } });
  };

  return (
    <StyledCard variant="outlined">
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
          <Typography mb={1} variant="h5" fontWeight={700} color="text.primary">
            W.O Inhouse Vs Outsource
          </Typography>

          <Stack direction="row" alignItems="center" gap={1}>
            <CustomSelectInput
              fullWidth={false}
              labelSize="14px"
              sx={{ width: 100 }}
              label="Year"
              options={yearsOptions}
              value={year}
              onChange={handleYearChange}
              placeholder="Select Year"
              disableClearable
              highlight
            />
            <CustomSelectInput
              fullWidth={false}
              labelSize="14px"
              sx={{ width: 100 }}
              label="Month"
              options={monthsOptions}
              value={month}
              onChange={handleMonthChange}
              placeholder="Select Month"
              disableClearable
              highlight
            />
          </Stack>
        </Stack>

        <Box mb={2}>
          <RadioGroup
            row
            aria-labelledby="work-order-chart"
            name="work-order-chart"
            value={selectedType}
            onChange={handleRadioChange}
          >
            <FormControlLabel value="schedule" control={<Radio size="small" />} label="Schedule" />
            <FormControlLabel value="unSchedule" control={<Radio size="small" />} label="Unschedule" />
          </RadioGroup>
        </Box>

        <Box width="100%">
          <PieChart
            series={[{ data: pieData }]}
            height={300}
            onItemClick={handlePieClick}
            slotProps={{
              legend: {
                direction: "row",
                position: { vertical: "bottom", horizontal: "middle" },
                padding: 0,
                itemMarkWidth: 15,
                itemMarkHeight: 15,
                markGap: 5,
                itemGap: 16,
                labelStyle: {
                  fontSize: 12,
                  color: "text.primary",
                  fontWeight: 400,
                },
              },
            }}
            margin={{ left: 60, bottom: 50, top: 50 }}
            
          />
        </Box>
      </CardContent>
    </StyledCard >
  );
}

export default Workorderinhousevsoutsource;
